/**
 * @module imports/protectors
 * @requires module:imports/auth
 */
import * as auth from './auth';

/**
 * protect login required page
 * @param {Object} props property of page
 * @throws {Object} have parameter to describe why reject and where route going.
 */
export function isLogin(props) {
    let canActive = auth.isLogin();
    if (!canActive) {
        throw Object({
            fallBackTo: '/login'
        });
    }
}